/* Autogenerated file. Do not edit manually. */

import type { BytesLike, JsonAbi } from 'fuels';

export const generationDate = 1725561405784;
// biome-ignore lint: Autogenerated file
export const abi: JsonAbi = {
  programType: 'predicate',
  specVersion: '1',
  encodingVersion: '1',
  concreteTypes: [
    {
      type: 'b256',
      concreteTypeId:
        '7c5ee1cecf5f8eacd1284feb5f0bf2bdea533a51e2f0c9aabe9236d335989f3b',
    },
    {
      type: 'bool',
      concreteTypeId:
        'b760f44fa5965c2474a3b471467a22c43185152129295af588b022ae50b50903',
    },
    {
      type: 'u64',
      concreteTypeId:
        '1506e6f44c1d6291cdf46395a8e573276a4fa79e8ace3fc891e092ef32d1b0a0',
    },
  ],
  metadataTypes: [],
  functions: [
    {
      inputs: [
        {
          name: 'witness_index',
          concreteTypeId:
            '1506e6f44c1d6291cdf46395a8e573276a4fa79e8ace3fc891e092ef32d1b0a0',
        },
      ],
      name: 'main',
      output:
        'b760f44fa5965c2474a3b471467a22c43185152129295af588b022ae50b50903',
      attributes: null,
    },
  ],
  loggedTypes: [],
  messagesTypes: [],
  configurables: [
    {
      name: 'SIGNER',
      concreteTypeId:
        '7c5ee1cecf5f8eacd1284feb5f0bf2bdea533a51e2f0c9aabe9236d335989f3b',
      offset: 1752,
    },
  ],
};
export const bin: BytesLike = new Uint8Array([
  26, 240, 48, 0, 116, 0, 0, 2, 0, 0, 0, 0, 0, 0, 6, 216, 93, 255, 192, 1, 16,
  255, 255, 0, 145, 0, 0, 32, 80, 235, 240, 0, 80, 228, 0, 32, 80, 224, 64, 0,
  32, 248, 51, 0, 88, 251, 224, 2, 80, 251, 224, 4, 116, 0, 0, 20, 26, 236, 80,
  0, 113, 64, 0, 3, 97, 69, 2, 0, 19, 73, 16, 0, 118, 72, 0, 6, 114, 72, 0, 2,
  19, 69, 20, 128, 118, 68, 0, 1, 54, 0, 0, 0, 97, 65, 2, 74, 116, 0, 0, 1, 97,
  65, 2, 12, 93, 65, 0, 0, 26, 233, 0, 0, 32, 248, 51, 0, 88, 251, 224, 2, 80,
  251, 224, 4, 116, 0, 0, 26, 26, 67, 208, 0, 36, 64, 0, 0, 149, 0, 0, 15, 150,
  8, 0, 0, 26, 236, 80, 0, 145, 0, 0, 96, 26, 67, 160, 0, 26, 75, 128, 0, 26,
  79, 224, 0, 114, 68, 0, 32, 40, 237, 4, 64, 80, 67, 176, 64, 114, 68, 0, 32,
  40, 67, 180, 64, 80, 71, 176, 32, 114, 64, 0, 32, 40, 71, 180, 0, 80, 67, 176,
  32, 114, 68, 0, 32, 40, 73, 4, 64, 26, 244, 0, 0, 146, 0, 0, 96, 26, 249, 48,
  0, 152, 8, 0, 0, 151, 0, 0, 15, 74, 248, 0, 0, 149, 0, 0, 255, 150, 8, 0, 0,
  26, 236, 80, 0, 145, 0, 4, 32, 26, 67, 160, 0, 26, 91, 224, 0, 97, 68, 0, 1,
  19, 73, 16, 0, 118, 72, 0, 9, 19, 69, 16, 64, 118, 68, 0, 1, 54, 0, 0, 0, 80,
  71, 176, 240, 95, 236, 16, 30, 80, 79, 178, 176, 114, 72, 0, 8, 40, 77, 20,
  128, 116, 0, 0, 5, 80, 71, 176, 184, 95, 236, 0, 23, 80, 79, 178, 176, 114,
  72, 0, 8, 40, 77, 20, 128, 80, 71, 177, 192, 114, 72, 0, 8, 40, 69, 52, 128,
  93, 71, 176, 56, 19, 69, 16, 0, 118, 68, 0, 7, 93, 71, 176, 56, 19, 69, 16,
  64, 118, 68, 0, 2, 93, 67, 240, 6, 54, 64, 0, 0, 97, 68, 1, 5, 116, 0, 0, 1,
  97, 68, 0, 7, 21, 73, 4, 64, 118, 72, 0, 1, 19, 73, 4, 64, 118, 72, 0, 20, 80,
  71, 177, 32, 95, 236, 16, 36, 97, 65, 4, 1, 80, 75, 178, 32, 26, 233, 0, 0,
  26, 229, 32, 0, 32, 248, 51, 0, 88, 251, 224, 2, 80, 251, 224, 4, 116, 0, 0,
  231, 26, 67, 208, 0, 114, 72, 0, 64, 40, 237, 4, 128, 80, 65, 16, 8, 114, 72,
  0, 64, 40, 67, 180, 128, 80, 75, 178, 184, 114, 64, 0, 72, 40, 73, 20, 0, 116,
  0, 0, 5, 80, 67, 176, 112, 95, 236, 0, 14, 80, 75, 178, 184, 114, 68, 0, 72,
  40, 73, 4, 64, 80, 67, 177, 200, 114, 68, 0, 72, 40, 65, 36, 64, 93, 67, 176,
  57, 19, 65, 0, 64, 118, 64, 0, 1, 54, 0, 0, 0, 80, 67, 177, 200, 80, 65, 0, 8,
  80, 71, 179, 144, 114, 72, 0, 64, 40, 69, 4, 128, 80, 67, 179, 144, 80, 71,
  179, 224, 114, 72, 0, 64, 40, 69, 4, 128, 26, 76, 0, 0, 80, 67, 178, 96, 114,
  68, 0, 32, 26, 233, 16, 0, 26, 229, 0, 0, 32, 248, 51, 0, 88, 251, 224, 2, 80,
  251, 224, 4, 116, 0, 0, 208, 26, 67, 208, 0, 80, 71, 176, 64, 114, 72, 0, 24,
  40, 69, 4, 128, 80, 67, 179, 96, 114, 72, 0, 24, 40, 65, 20, 128, 114, 64, 0,
  32, 95, 237, 0, 110, 93, 67, 176, 108, 114, 68, 0, 32, 40, 65, 52, 64, 80, 67,
  179, 96, 80, 71, 179, 72, 114, 72, 0, 24, 40, 69, 4, 128, 80, 67, 178, 120,
  114, 68, 0, 64, 26, 233, 16, 0, 26, 229, 0, 0, 32, 248, 51, 0, 88, 251, 224,
  2, 80, 251, 224, 4, 116, 0, 0, 184, 26, 67, 208, 0, 80, 71, 176, 88, 114, 72,
  0, 24, 40, 69, 4, 128, 80, 67, 179, 48, 114, 72, 0, 24, 40, 65, 20, 128, 26,
  92, 0, 0, 114, 64, 0, 32, 22, 65, 116, 0, 118, 64, 0, 75, 80, 67, 179, 48, 80,
  71, 179, 120, 114, 72, 0, 24, 40, 69, 4, 128, 80, 64, 64, 0, 80, 71, 179, 224,
  80, 75, 179, 120, 93, 79, 176, 113, 19, 81, 48, 0, 118, 80, 0, 38, 80, 83,
  178, 160, 114, 84, 0, 16, 40, 81, 37, 64, 26, 233, 64, 0, 32, 248, 51, 0, 88,
  251, 224, 2, 80, 251, 224, 4, 116, 0, 0, 171, 26, 75, 208, 0, 80, 83, 177,
  144, 114, 84, 0, 32, 40, 81, 5, 64, 64, 81, 20, 147, 26, 64, 128, 0, 19, 65,
  0, 64, 118, 64, 0, 8, 80, 67, 177, 128, 95, 236, 0, 48, 80, 69, 0, 15, 94, 68,
  16, 0, 80, 75, 179, 16, 114, 68, 0, 16, 40, 73, 4, 64, 116, 0, 0, 10, 80, 67,
  177, 104, 95, 236, 16, 45, 80, 71, 177, 120, 95, 236, 0, 47, 80, 73, 0, 8,
  114, 76, 0, 8, 40, 73, 20, 192, 80, 75, 179, 16, 114, 68, 0, 16, 40, 73, 4,
  64, 80, 71, 179, 32, 114, 64, 0, 16, 40, 69, 36, 0, 116, 0, 0, 10, 80, 67,
  176, 224, 95, 236, 16, 28, 80, 71, 177, 24, 95, 236, 16, 35, 80, 73, 0, 8,
  114, 76, 0, 8, 40, 73, 20, 192, 80, 71, 179, 32, 114, 72, 0, 16, 40, 69, 4,
  128, 80, 67, 179, 208, 114, 72, 0, 16, 40, 65, 20, 128, 80, 67, 179, 208, 80,
  71, 177, 176, 114, 72, 0, 16, 40, 69, 4, 128, 93, 67, 176, 54, 19, 65, 0, 0,
  26, 68, 16, 0, 118, 64, 0, 1, 26, 68, 0, 0, 118, 68, 0, 2, 26, 244, 0, 0, 116,
  0, 0, 78, 26, 244, 16, 0, 116, 0, 0, 76, 80, 67, 179, 72, 93, 71, 176, 107,
  22, 73, 21, 192, 118, 72, 0, 1, 19, 73, 21, 192, 118, 72, 0, 19, 80, 71, 178,
  144, 114, 72, 0, 16, 40, 69, 4, 128, 26, 233, 16, 0, 32, 248, 51, 0, 88, 251,
  224, 2, 80, 251, 224, 4, 116, 0, 0, 100, 26, 67, 208, 0, 16, 65, 5, 192, 80,
  71, 176, 248, 95, 236, 16, 31, 92, 65, 0, 0, 80, 73, 16, 15, 94, 73, 0, 0, 80,
  75, 179, 0, 114, 64, 0, 16, 40, 73, 20, 0, 116, 0, 0, 5, 80, 67, 176, 192, 95,
  236, 0, 24, 80, 75, 179, 0, 114, 68, 0, 16, 40, 73, 4, 64, 80, 67, 178, 16,
  114, 68, 0, 16, 40, 65, 36, 64, 93, 67, 176, 66, 19, 65, 0, 64, 118, 64, 0, 1,
  54, 0, 0, 0, 93, 67, 240, 7, 16, 65, 0, 192, 80, 71, 178, 16, 80, 69, 16, 15,
  92, 69, 16, 0, 80, 75, 179, 48, 80, 79, 176, 208, 114, 80, 0, 16, 40, 77, 5,
  0, 114, 80, 0, 4, 31, 81, 21, 0, 114, 84, 0, 1, 27, 81, 69, 64, 16, 81, 53, 0,
  92, 77, 64, 0, 26, 233, 32, 0, 26, 229, 48, 0, 32, 248, 51, 0, 88, 251, 224,
  2, 80, 251, 224, 4, 116, 0, 0, 67, 80, 75, 179, 48, 80, 79, 177, 8, 114, 80,
  0, 16, 40, 77, 5, 0, 114, 64, 0, 15, 17, 65, 20, 0, 114, 68, 0, 1, 27, 65, 4,
  64, 16, 65, 52, 0, 92, 65, 0, 0, 26, 233, 32, 0, 26, 229, 0, 0, 32, 248, 51,
  0, 88, 251, 224, 2, 80, 251, 224, 4, 116, 0, 0, 51, 16, 93, 112, 64, 117, 0,
  0, 152, 146, 0, 4, 32, 26, 249, 96, 0, 152, 8, 0, 0, 151, 0, 0, 255, 74, 248,
  0, 0, 149, 0, 0, 15, 150, 8, 0, 0, 26, 236, 80, 0, 145, 0, 0, 64, 26, 67, 160,
  0, 26, 71, 144, 0, 26, 75, 224, 0, 114, 76, 0, 64, 40, 237, 4, 192, 114, 64,
  0, 64, 40, 71, 180, 0, 26, 245, 16, 0, 146, 0, 0, 64, 26, 249, 32, 0, 152, 8,
  0, 0, 151, 0, 0, 15, 74, 248, 0, 0, 149, 0, 0, 15, 150, 8, 0, 0, 26, 236, 80,
  0, 26, 67, 160, 0, 26, 71, 144, 0, 26, 75, 224, 0, 38, 64, 0, 0, 26, 76, 112,
  0, 95, 69, 48, 0, 95, 69, 0, 1, 95, 68, 0, 2, 26, 245, 16, 0, 26, 249, 32, 0,
  152, 8, 0, 0, 151, 0, 0, 15, 74, 248, 0, 0, 149, 0, 0, 3, 150, 8, 0, 0, 26,
  236, 80, 0, 26, 67, 160, 0, 26, 71, 224, 0, 93, 65, 0, 0, 26, 245, 0, 0, 26,
  249, 16, 0, 152, 8, 0, 0, 151, 0, 0, 3, 74, 248, 0, 0, 149, 0, 0, 255, 150, 8,
  0, 0, 26, 236, 80, 0, 145, 0, 0, 16, 26, 67, 160, 0, 26, 71, 144, 0, 26, 75,
  224, 0, 93, 77, 0, 2, 93, 81, 0, 1, 19, 77, 53, 0, 118, 76, 0, 1, 116, 0, 0,
  21, 93, 77, 0, 1, 19, 77, 48, 0, 26, 80, 16, 0, 118, 76, 0, 3, 93, 77, 0, 1,
  114, 80, 0, 2, 27, 81, 68, 192, 93, 77, 0, 0, 93, 85, 0, 1, 21, 89, 69, 64,
  26, 93, 48, 0, 118, 88, 0, 1, 116, 0, 0, 6, 38, 80, 0, 0, 26, 92, 112, 0, 21,
  89, 80, 0, 118, 88, 0, 1, 116, 0, 0, 1, 40, 93, 53, 64, 95, 65, 112, 0, 95,
  65, 64, 1, 114, 76, 0, 16, 40, 237, 4, 192, 26, 235, 176, 0, 32, 248, 51, 0,
  88, 251, 224, 2, 80, 251, 224, 4, 117, 0, 0, 49, 26, 79, 208, 0, 93, 81, 0, 2,
  16, 77, 53, 0, 94, 77, 16, 0, 93, 69, 0, 2, 16, 69, 16, 64, 95, 65, 16, 2, 26,
  244, 0, 0, 146, 0, 0, 16, 26, 249, 32, 0, 152, 8, 0, 0, 151, 0, 0, 255, 74,
  248, 0, 0, 71, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0,
  0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 48, 49, 50, 51, 52, 53, 54, 55, 56,
  57, 97, 98, 99, 100, 101, 102, 204, 204, 204, 204, 204, 204, 0, 2, 0, 0, 0, 0,
  0, 0, 2, 84,
]);
